import { useState } from "react";
import { CalendarIcon } from "lucide-react";
import { format } from "date-fns";
import { cn } from "../../../lib/utils";
import { Button } from "../../../components/ui/button";
import { Calendar } from "../../../components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../../../components/ui/popover";

export function LeaveDateField({
  placeholder,
  value,
  onChange,
  disabled = false,
  className,
  error = false,
  dateFormat = "dd MMM yyyy",
}) {
  const [open, setOpen] = useState(false);

  const handleSelect = (date) => {
    onChange(date);
    if (date) {
      setOpen(false);
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          disabled={disabled}
          className={cn(
            "h-11 w-full justify-start text-left font-normal rounded-xl border-(--color-text-border) bg-white hover:bg-workspace/40 text-sm px-4",
            !value && "text-muted-foreground",
            error && "border-error",
            className
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4 per-file-hint" />
          {value ? format(value, dateFormat) : <span>{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto border-0 bg-transparent p-0 shadow-none" align="start">
        <Calendar
          mode="single"
          selected={value}
          onSelect={handleSelect}
          initialFocus
          className={cn("p-3 pointer-events-auto")}
        />
      </PopoverContent>
    </Popover>
  );
}
